import {
  Accordion,
  Button,
  ButtonLayout,
  Checkbox,
  CheckboxGroup,
  Layout,
  LinkNavigation,
  LinkNavigationGroup,
  Modal,
  TagFilter,
  TagFilterGroup,
  Title,
  Spacer
} from "@common/AggregationComponent";
import {
  transformBrandForGoogleAnalytics,
  handleDuplicate,
  getEcRenewalCompatibility
} from "@util/common";
import { sendTrackEvent, TRACK_EVENT_SEARCH } from "@util/gtm";
import { useSelector } from "react-redux";
import type { CombinedReducersType } from "@type/index";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export interface FilterModelArgs {
  visible: boolean;
  total: number | string;
  tree: any;
  sizes: any[];
  visibleSize: boolean;
  visibleCategory: boolean;
  categoryType: string;
  selectedSizes: any[];
  filteredSizes: any[];
  selectedCategories: any[];
  searchCategories: any[];
  searchSizes: any[];
  onChangeSelectedSizes: (sizes: any[]) => void;
  onChangeSelectedCategories: (sizes: any[]) => void;
  handlerSizeExpand: () => void;
  handlerCategoryExpand: () => void;
  handlerClearAllFilter: () => void;
  setFilteredSizes: (size: any) => void;
  onClose: () => void;
  setIsClickSizeCheckList: any;
}

interface SelectedTagsType {
  filterSizes: any[];
  filtercategories: any[];
}

enum TAG_TYPE {
  SIZE = "size",
  CATEGORY = "category"
}

const FilterModel = (props: FilterModelArgs) => {
  const {
    visible,
    total,
    tree,
    sizes,
    visibleSize,
    visibleCategory,
    categoryType,
    selectedSizes,
    filteredSizes,
    selectedCategories,
    onChangeSelectedSizes,
    onChangeSelectedCategories,
    // onChangeSearchParams,
    handlerSizeExpand,
    handlerCategoryExpand,
    handlerClearAllFilter,
    setFilteredSizes,
    onClose,
    setIsClickSizeCheckList
  } = props;
  const { t } = useTranslation();
  const config = useSelector((store: CombinedReducersType) => store.app);
  const [filteredCategories, setFilteredCategories] = useState<any[]>([]);
  const getSelectedTags = useCallback(
    (): SelectedTagsType => ({
      filterSizes: handleDuplicate(
        selectedSizes
          .map((size: any) => ({ ...size, type: TAG_TYPE.SIZE }))
          .sort(
            (sizeA: any, sizeB: any) => sizeA.displayCode - sizeB.displayCode
          ),
        "name"
      ),
      filtercategories: selectedCategories
        .map((size: any) => ({ ...size, type: TAG_TYPE.CATEGORY }))
        .sort((sizeA: any, sizeB: any) => sizeA.id - sizeB.id)
    }),
    [selectedSizes, selectedCategories, sizes.length]
  );

  const handlerCategoryClick = (category: any) => {
    const gaCatArr: any = getSelectedTags().filtercategories.map(
      (item) => item.name
    );
    // 向tag中添加category
    if (
      selectedCategories.findIndex(
        (selectedSize) => selectedSize.id === category.id
      ) === -1
    ) {
      gaCatArr.push(category.name);
      // Are there categories of the same category
      const isHasCategoryTypeIndex = selectedCategories.findIndex(
        (item: any) => item.categoryType === category.categoryType
      );
      if (isHasCategoryTypeIndex > -1) {
        const newSelectedCategories = JSON.parse(
          JSON.stringify(selectedCategories)
        );
        newSelectedCategories.splice(isHasCategoryTypeIndex, 1, category);
        onChangeSelectedCategories([...newSelectedCategories]);
      } else {
        onChangeSelectedCategories([...selectedCategories, category]);
      }
    }
    const sizesForGa = getSelectedTags().filterSizes.map((item) => item.name);
    const genderForGa = gaCatArr[0] || null;
    const categoryForGa = gaCatArr.slice(1).join(",") || null;
    sendTrackEvent({
      brand: transformBrandForGoogleAnalytics(config.brand_name),
      event: TRACK_EVENT_SEARCH,
      eventAction: "ImageItemSearch",
      eventCategory: "IS_Item_Filter",
      eventLabel: `${[...gaCatArr, ...sizesForGa].join(",")}`,
      genderFilter: genderForGa,
      categoryFilter: categoryForGa,
      sizeFilter: sizesForGa.join(",") || null
    });
  };
  const handlerDeleteTag = (tag: any) => {
    // cateegroy
    if (tag.type === TAG_TYPE.CATEGORY) {
      const selectedCategoryIndex = selectedCategories.findIndex(
        (category: any) => category.id === tag.id
      );
      const newCategories = JSON.parse(JSON.stringify(selectedCategories));
      if (selectedCategoryIndex > -1) {
        newCategories.splice(selectedCategoryIndex);
        onChangeSelectedCategories([...newCategories]);
      } else {
        onChangeSelectedCategories([...newCategories]);
      }
      const gaNewCategories = newCategories.map((item: any) => item.name);
      const sizesForGa = getSelectedTags().filterSizes.map((item) => item.name);
      const genderForGa = gaNewCategories[0] || null;
      const categoryForGa = gaNewCategories.slice(1).join(",") || null;
      sendTrackEvent({
        brand: transformBrandForGoogleAnalytics(config.brand_name),
        event: TRACK_EVENT_SEARCH,
        eventAction: "ImageItemSearch",
        eventCategory: "IS_Item_Filter",
        eventLabel: `${[...gaNewCategories, ...sizesForGa].join(",")}`,
        genderFilter: genderForGa,
        categoryFilter: categoryForGa,
        sizeFilter: sizesForGa.join(",") || null
      });
    }
    if (tag.type === TAG_TYPE.SIZE) {
      // size
      const selectedSizeIndex = selectedSizes.findIndex(
        (size: any) => size.code === tag.code
      );
      const newSizes = JSON.parse(JSON.stringify(selectedSizes));
      if (selectedSizeIndex > -1) {
        const newSelectedSizes = selectedSizes;
        newSelectedSizes.splice(selectedSizeIndex, 1);
        onChangeSelectedSizes([...newSelectedSizes]);
      } else {
        onChangeSelectedSizes([...newSizes]);
      }
      const sizeIndex = filteredSizes.findIndex(
        (filteredSize) => filteredSize.code === tag.code
      );
      const newFilterSizes = JSON.parse(JSON.stringify(filteredSizes));
      if (sizeIndex > -1) {
        const newFilteredSizes = filteredSizes;
        newFilteredSizes[sizeIndex].checked = false;
        setFilteredSizes([...newFilteredSizes]);
      } else {
        setFilteredSizes([...newFilterSizes]);
      }
      const sizesForGa = newSizes.map((item: any) => item.name);
      const catAndGenArr = getSelectedTags().filtercategories.map(
        (item) => item.name
      );
      const genderForGa = catAndGenArr[0] || null;
      const categoryForGa = catAndGenArr.slice(1).join(",") || null;
      sendTrackEvent({
        brand: transformBrandForGoogleAnalytics(config.brand_name),
        event: TRACK_EVENT_SEARCH,
        eventAction: "ImageItemSearch",
        eventCategory: "IS_Item_Filter",
        eventLabel: `${[...catAndGenArr, ...sizesForGa].join(",")}`,
        genderFilter: genderForGa,
        categoryFilter: categoryForGa,
        sizeFilter: sizesForGa
      });
    }
  };
  const handlerSizeClick = (size: any) => {
    setIsClickSizeCheckList(true);
    let gaSizeArr: any = getSelectedTags().filterSizes.map((item) => item.name);
    const index = selectedSizes.findIndex(
      (selectedSize) => selectedSize.code === size.code
    );
    if (index === -1) {
      gaSizeArr.push(size.name);
      // 选择的tag 添加一个size tag
      onChangeSelectedSizes([...selectedSizes, size]);
      const sizeIndex = filteredSizes.findIndex(
        (filteredSize) => filteredSize.code === size.code
      );
      // 勾选size
      if (sizeIndex > -1) {
        const newSizes = filteredSizes;
        newSizes[sizeIndex].checked = true;
        setFilteredSizes([...newSizes]);
      }
    } else {
      // 点击取消 删除选择的size tag
      const newSizes = selectedSizes;
      newSizes.splice(index, 1);
      gaSizeArr = newSizes.map((item) => item.name);
      onChangeSelectedSizes([...newSizes]);
      const sizeIndex = filteredSizes.findIndex(
        (filteredSize) => filteredSize.code === size.code
      );
      // 点击取消 取消size勾选状态
      if (sizeIndex > -1) {
        const newFilteredSizes = filteredSizes;
        newFilteredSizes[sizeIndex].checked = false;
        setFilteredSizes([...newFilteredSizes]);
      }
    }
    const sizesForGa = gaSizeArr.join(",");
    const catAndGenArr = getSelectedTags().filtercategories.map(
      (item) => item.name
    );
    const genderForGa = catAndGenArr[0] || null;
    const categoryForGa = catAndGenArr.slice(1).join(",") || null;
    sendTrackEvent({
      brand: transformBrandForGoogleAnalytics(config.brand_name),
      event: TRACK_EVENT_SEARCH,
      eventAction: "ImageItemSearch",
      eventCategory: "IS_Item_Filter",
      eventLabel: `${[...catAndGenArr, ...gaSizeArr].join(",")}`,
      genderFilter: genderForGa,
      categoryFilter: categoryForGa,
      sizeFilter: sizesForGa
    });
  };
  const handlerClearAllCaTegory = () => {
    onChangeSelectedCategories([]);
  };
  const handlerSubmit = () => {
    onClose();
  };
  const updateSizesStatus = () => {
    const newSizes = JSON.parse(JSON.stringify([...sizes]));
    selectedSizes.forEach((selectedSize: any) => {
      const searchCodeIndex = newSizes.findIndex(
        (size: any) => size.code === selectedSize.code
      );
      if (searchCodeIndex > -1) {
        newSizes[searchCodeIndex].checked = true;
      }
    });
    setFilteredSizes(newSizes);
  };
  const updateSearchCategoriesStatus = () => {
    let newCategories = [];
    if (tree[categoryType] && tree[categoryType].length) {
      newCategories = tree[categoryType].map((item: any) => ({
        ...item,
        categoryType: categoryType
      }));
    }
    setFilteredCategories(newCategories);
  };
  const ClearAllcCategoryTag = ({
    onClickClearAllCaTegory,
    selectedCount
  }: any) => {
    if (
      filteredCategories &&
      filteredCategories.length === 0 &&
      selectedCount
    ) {
      return (
        <LinkNavigation
          element="button"
          gaAction="click"
          gaCallback={undefined}
          gaCategory=""
          gaLabel=""
          gaValue={null}
          iconPosition="end"
          selected={false}
          variant="TitleStandard"
          onClick={onClickClearAllCaTegory}
        >
          {t("text_filter_clear_all_category")}
        </LinkNavigation>
      );
    }
    return <></>;
  };

  // 刷新页面的时候重新初始化
  useEffect(() => {
    updateSearchCategoriesStatus();
    updateSizesStatus();
  }, [sizes, tree]);
  useEffect(() => {
    updateSizesStatus();
  }, [categoryType]);
  return (
    <Layout
      colSpan={{ lg: 6, md: 12, sm: 4 }}
      visible={{
        lg: false,
        md: true,
        sm: true
      }}
    >
      <Modal
        closeTitle={t("text_close")}
        closeLabel={getEcRenewalCompatibility() ? " " : t("text_close")}
        errors={[]}
        id="sm-1"
        labelElement="h5"
        onBackdropClick={undefined}
        onRequestClose={onClose}
        title={t("text_filter")}
        titleId="modal-title"
        itemCount={`${t("text_image_search_result_number", { total: total })}`}
        trapFocus
        variant="filter"
        isOpen={visible}
        footer={
          <ButtonLayout reverseOnVertical={false} variant="fluid">
            <Button
              element="button"
              isSmall={false}
              variant="primary"
              width="fullWidth"
              onClick={handlerSubmit}
            >
              {t("text_apply_search_filter")}
            </Button>
          </ButtonLayout>
        }
      >
        <Spacer element="div" variant={"spacing-05"} />
        {(getSelectedTags().filtercategories.length > 0 ||
          getSelectedTags().filterSizes.length > 0) && (
          <div className="fr-ec-mb-spacing-05">
            <Title
              color="primary-dark"
              element="h1"
              textAlign="left"
              textTransform="title-case"
              variant="large"
              className="fr-ec-mb-spacing-04"
            >
              {t("text_active_filters")}
            </Title>
            <TagFilterGroup
              clearLabel={t("text_image_search_clear_all_filters")}
              onClear={handlerClearAllFilter}
            >
              {getSelectedTags().filtercategories.map((category: any) => (
                <TagFilter
                  disabled={false}
                  value={category.name}
                  key={category.id}
                  onClick={() => {
                    handlerDeleteTag(category);
                  }}
                />
              ))}
              {getSelectedTags().filterSizes.map((size: any) => (
                <TagFilter
                  disabled={false}
                  value={size.name}
                  key={size.code}
                  onClick={() => {
                    handlerDeleteTag(size);
                  }}
                />
              ))}
            </TagFilterGroup>
          </div>
        )}
        <Accordion
          disabled={false}
          element="div"
          id="accordion-id"
          label={t("text_category")}
          labelChildren=""
          labelElement="h1"
          onClose={handlerCategoryExpand}
          onExpand={handlerCategoryExpand}
          variant="small"
          expanded={visibleCategory}
        >
          <LinkNavigationGroup
            indented
            labelId="1"
            padding="default"
            variant="vertical"
          >
            {filteredCategories.map((category: any) => (
              <LinkNavigation
                key={category.id}
                element="button"
                gaAction="click"
                gaCallback={undefined}
                gaCategory=""
                gaLabel=""
                gaValue={null}
                iconPosition="end"
                selected={false}
                variant="TitleStandard"
                onClick={() => {
                  handlerCategoryClick(category);
                }}
              >
                {category.name}
              </LinkNavigation>
            ))}
            {
              <ClearAllcCategoryTag
                onClickClearAllCaTegory={handlerClearAllCaTegory}
                selectedCount={getSelectedTags().filtercategories.length}
              />
            }
          </LinkNavigationGroup>
        </Accordion>
        <Accordion
          disabled={false}
          element="div"
          id="accordion-id"
          label={t("text_size")}
          labelChildren=""
          labelElement="h1"
          onClose={handlerSizeExpand}
          onExpand={handlerSizeExpand}
          variant="small"
          expanded={visibleSize}
        >
          <CheckboxGroup
            error=""
            hint=""
            id="Checkbox-color-17"
            required={false}
            columnCount={{ sm: 2, md: 2, lg: 1 }}
          >
            {filteredSizes.map((size: any) => (
              <Checkbox
                checked={!!size.checked}
                id={size.code}
                key={size.code}
                label={size.name}
                name={size.name}
                onChange={() => {
                  handlerSizeClick(size);
                }}
                value={size.code}
              />
            ))}
          </CheckboxGroup>
        </Accordion>
      </Modal>
    </Layout>
  );
};
export default FilterModel;
